<template>
  <div
    class="question-alternative-component"
    :class="{ selected }"
    @click="$emit('click')"
  >
    <div class="d-flex gap-3">
      <bp-icon size="20" :icon="icon" />
      <span>{{ title }}</span>
    </div>
  </div>
</template>
<script>
const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");
export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    icon() {
      return `
        fa-${this.selected ? "solid" : "light"}
        fa-circle-${alphabet[this.index]}
      `;
    }
  }
};
</script>
<style lang="scss">
.question-alternative-component {
  width: 100%;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  background-color: white;
  border: 1px solid $neutral-100;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    border-color: $primary-200;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
  }

  &:active {
    border-color: $primary-100;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
  }

  &.selected {
    border-color: $primary-400;
    color: $primary-600;
  }
}
</style>
